<template>
    <div>
        <HeaderStock header="คลัง" :img_header="header_image" link_back="stockinout" />
        <MenuStockList/>
        <AddLotoutList/>
    </div>
</template>

<script>
import HeaderImage from '@/assets/icon-stock.png'
import HeaderStock from '@/components/menuadmin/stock/stockheader/HeaderStock.vue'
import MenuStockList from '@/components/menuadmin/stock/stocklist/MenuStockList.vue'
import AddLotoutList from '@/components/menuadmin/stock/stocklist/AddLotoutList.vue'

export default {
    name:'addLotout',
    components:{
        HeaderStock,
        MenuStockList,
        AddLotoutList,
    },
    data(){
        return{
            header_image:HeaderImage
        }
    }
}
</script>